module.exports = __webpack_public_path__ + "img/TBK_Logo.506b04a9.png";